var _defs, _path, _path2, _path3, _path4, _g, _g2, _path5, _g3, _path6, _path7, _path8, _path9, _path10, _g4, _path11, _path12, _g5, _rect, _polygon, _path13, _g6, _g7, _path14, _path15, _path16, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 465.3 451.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}.cls-2{fill:#ebebeb;}.cls-3{fill:#e0e0e0;}.cls-4{fill:#92e3a9;}.cls-5,.cls-8{fill:#fff;}.cls-5{opacity:0.7;isolation:isolate;}.cls-6{fill:#263238;}.cls-7{fill:#b5b5b5;}.cls-9{opacity:0.3;}.cls-10{fill:#367d57;}.cls-11{font-size:73.38px;}.cls-11,.cls-16{fill:#0e6b44;font-family:HurmeGeometricSans2-SemiBold, \"Hurme Geometric Sans 2\";font-weight:600;}.cls-12{letter-spacing:-0.01em;}.cls-13{letter-spacing:0em;}.cls-14{letter-spacing:0em;}.cls-15{letter-spacing:-0.02em;}.cls-16{font-size:76.98px;}.cls-17{letter-spacing:-0.01em;}.cls-18{letter-spacing:-0.03em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M468.8,353.9A28,28,0,1,1,437,330.2h0a27.94,27.94,0,0,1,31.8,23.7Z",
    transform: "translate(-19.7 -23.02)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M462.2,354.8a21.38,21.38,0,1,1-24.3-18h0a21.37,21.37,0,0,1,24.3,18Z",
    transform: "translate(-19.7 -23.02)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.1,354.1a10.64,10.64,0,0,1-.9-2.5,20.32,20.32,0,0,0-3.4-6.1,21.78,21.78,0,0,0-8-6.4,13.32,13.32,0,0,0-2.8-1,15.94,15.94,0,0,0-3-.6c-1.1-.1-2.1-.2-3.2-.2a18.41,18.41,0,0,0-3.3.3c-1.1.2-2.1.5-3.2.8a15.11,15.11,0,0,0-2.9,1.3,22.61,22.61,0,0,0-2.6,1.6,21.1,21.1,0,0,0-2.3,1.9,20.13,20.13,0,0,0-3.4,4.3,24.82,24.82,0,0,0-2,4.4,23.3,23.3,0,0,0-1.1,7,11.29,11.29,0,0,1,0,2.6,5.83,5.83,0,0,1-.6-2.6,18.13,18.13,0,0,1,.6-7.3,21.06,21.06,0,0,1,1.9-4.7,19.84,19.84,0,0,1,3.5-4.7,12.06,12.06,0,0,1,2.4-2.1,16.65,16.65,0,0,1,2.8-1.8,30.9,30.9,0,0,1,3.2-1.4,20,20,0,0,1,3.5-.9,21.59,21.59,0,0,1,3.5-.3c1.2,0,2.3.1,3.5.2a30.05,30.05,0,0,1,3.2.7,18.77,18.77,0,0,1,3,1.2,21.66,21.66,0,0,1,8.3,7,21,21,0,0,1,3.1,6.6A8.22,8.22,0,0,1,462.1,354.1Z",
    transform: "translate(-19.7 -23.02)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M445.3,370.2l.6,3.7-3.3.5-.6-3.6a16,16,0,0,1-8.6-1.3l1.2-4.3a13.17,13.17,0,0,0,6.8,1.3l-.9-5.5c-3.8-.3-8.1-.9-8.8-5.6-.6-3.5,1.5-6.9,6.6-8.3l-.6-3.6,3.3-.5.6,3.6a16.72,16.72,0,0,1,7,.9l-1,4.3a12.11,12.11,0,0,0-5.3-.9l.9,5.6c3.8.3,8,.8,8.7,5.5C452.3,365.4,450.3,368.7,445.3,370.2Zm-5.6-14-.7-4.6c-1.7.7-2.2,1.7-2,2.8C437,355.4,438.1,355.9,439.7,356.2Zm6.9,6.9c-.2-1.2-1.2-1.6-2.7-1.9l.7,4.5a2.39,2.39,0,0,0,2-2.6Z",
    transform: "translate(-19.7 -23.02)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M447.1,175.6c8.2,39.8,5.5,90.1-22.6,122.1-42.5,48.4-22.3,94.5-118.4,149.4a223.39,223.39,0,0,1-44.2,19.5,179.35,179.35,0,0,1-23,5.6c-68.6,12.2-127.8-18.7-162.2-68.3-45.2-65.2-18.5-126.5.2-164.4S86.7,106.1,180.8,51.4a216.17,216.17,0,0,1,45.4-20c36.3-11.1,79.4-12.3,114.8,3.3,2.7,1.2,5.3,2.4,7.9,3.8C399.4,64.7,436,121.3,447.1,175.6Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M447.1,175.6c8.2,39.8,5.5,90.1-22.6,122.1-42.5,48.4-22.3,94.5-118.4,149.4a223.39,223.39,0,0,1-44.2,19.5,179.35,179.35,0,0,1-23,5.6c-68.6,12.2-127.8-18.7-162.2-68.3-45.2-65.2-18.5-126.5.2-164.4S86.7,106.1,180.8,51.4a216.17,216.17,0,0,1,45.4-20c36.3-11.1,79.4-12.3,114.8,3.3,2.7,1.2,5.3,2.4,7.9,3.8C399.4,64.7,436,121.3,447.1,175.6Z",
    transform: "translate(-19.7 -23.02)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M484.3,460.1H471.7a.61.61,0,1,1,0-1.2h12.6a.61.61,0,1,1,0,1.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M464.9,460.1H20.4a.67.67,0,0,1-.7-.6c0-.4.3-.6.7-.6H464.9a.61.61,0,1,1,0,1.2Z",
    transform: "translate(-19.7 -23.02)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.9,365.5H161.3c.3,0,.7.1,1,.1a7.81,7.81,0,0,1,6.9,5.5c.4,1.3.7,2.5,1.1,3.8,6.7,25,13.4,49.9,20.1,74.9.3,1.1.6,2.3.9,3.4.8,3.2-.9,5.5-4.1,5.6H65.3a7.86,7.86,0,0,1-7.2-5.6c-.8-3-1.7-6-2.5-9Q46.9,411.65,38.1,379c-.7-2.6-1.3-5.2-2-7.8-.8-2.9.8-5.5,4-5.6C40.3,365.6,40.6,365.5,40.9,365.5Zm78.9,41.8a5.27,5.27,0,0,0-6.3-1.4,2.85,2.85,0,0,1-2.7,0,.6.6,0,0,0-.4-.1c-2.5-.8-4.3,0-5,2.1a5.26,5.26,0,0,0,.1,3.7,17.33,17.33,0,0,0,5.2,7.7c1.4,1.2,2.4,1.3,3.5.7a4.22,4.22,0,0,1,3.8,0c1.6.6,2.6.4,3.2-.8a14.46,14.46,0,0,0,1.1-2.9,4.1,4.1,0,0,0,.1-1.1C118.9,413.3,117.4,410,119.8,407.3Zm-5.3-6.5a2.83,2.83,0,0,0-2.6,4.3C114.1,405.4,115.4,403.2,114.5,400.8Z",
    transform: "translate(-19.7 -23.02)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M279.3,322.9s-47.5,9-52.7,16.2-18.3,45.4-19.4,47.1-23.5,35.1-26.8,44.8-.8,18.2,7.5,23.5,16.9,2.8,21,2.8,14.9-9.1,15.8-13S228,430,228,430l15.5-27.1,9.4,56.4H382l8.8-53.9,27.1,49.7h44.7l-27.9-59.4-15.5-27.9s-6.1-20.7-15.5-29.3-22.4-11.3-26.8-11.6-16.3-3-22.4-4.4-18.8-5.5-18.8-5.5Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M381.9,459.8H252.8a.56.56,0,0,1-.6-.5l-9.1-54.6-14.6,25.5c-.3,1-2.5,10.6-3.3,14.3-.9,4.3-12.1,13.5-16.3,13.5-.8,0-1.9.1-3.1.2-4.6.5-11.5,1.2-18.3-3.1-8.4-5.3-11.2-14.1-7.7-24.2,3.1-9.1,22.9-38.9,26.8-44.8l.1-.1c.3-.5,1.9-4.7,3.7-9.6,4.5-12.1,12-32.4,15.7-37.5,5.3-7.3,51.2-16.1,53.1-16.5h0l56.4-6.1h.3c.1,0,12.8,4.2,18.7,5.5l1.3.3c6.3,1.4,16.9,3.9,21,4.1s17.5,2.9,27.2,11.8c9.2,8.4,15.2,28,15.6,29.5l15.4,27.9L463,454.9a.64.64,0,0,1,0,.6.55.55,0,0,1-.5.3H417.7a.55.55,0,0,1-.5-.3L391,407.2l-8.5,52.1C382.4,459.5,382.2,459.8,381.9,459.8Zm-128.5-1.3h128l8.8-53.4a.54.54,0,0,1,.5-.5.91.91,0,0,1,.7.3l26.9,49.4h43.4l-27.5-58.5L418.6,368v-.1c-.1-.2-6.1-20.7-15.3-29-9.4-8.6-22.6-11.2-26.4-11.4-4.2-.3-14.8-2.7-21.2-4.1l-1.3-.3c-5.7-1.3-17.4-5-18.7-5.5l-56.2,6.1c-1.3.3-47.3,9.1-52.3,16-3.6,4.9-11.1,25.1-15.6,37.2-2.3,6.3-3.5,9.3-3.8,9.9l-.1.1c-3.9,5.9-23.6,35.5-26.7,44.5-3.3,9.6-.7,17.7,7.2,22.8,6.4,4,13.1,3.4,17.5,2.9,1.3-.1,2.3-.2,3.2-.2,3.8,0,14.3-8.8,15.1-12.5s3.3-14.3,3.3-14.4v-.2l15.5-27.1a.78.78,0,0,1,.7-.3.54.54,0,0,1,.5.5Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.9,428.3a.52.52,0,0,1-.4-.2c-14-12-29-9.9-29.1-9.9-.3,0-.7-.2-.7-.5a.59.59,0,0,1,.5-.7h0c.2,0,15.6-2.2,30.1,10.2a.63.63,0,0,1,.1.9,1.69,1.69,0,0,1-.5.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M402.4,426.7c8.5-5.4,24-14.6,38-18.8l-5.8-12.3-15.5-27.9S413,347,403.6,338.4s-22.4-11.3-26.8-11.6-16.3-3-22.4-4.4-18.8-5.5-18.8-5.5L279.2,323s-43.1,7-52.7,16.2c-12,11.4-18.3,45.4-19.4,47.1-.5.8-5.5,8.2-11,17,6,4.9,19.5,14.7,36.2,18.8l11-19.3,9.4,56.4H381.8l8.8-53.9Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M381.9,459.8H252.8a.56.56,0,0,1-.6-.5l-9.1-54.6L233,422.4a.61.61,0,0,1-.7.3c-16.6-4.2-30-13.7-36.5-19a.61.61,0,0,1-.1-.8c4.6-7.2,8.8-13.6,10.9-16.8l.1-.2a32.15,32.15,0,0,0,1.3-4.8c2.5-10,8.6-33.3,18.1-42.4s51.3-16.1,53.1-16.3l56.4-6.1h.3c.1,0,12.8,4.2,18.7,5.5l1.3.3c6.3,1.4,16.9,3.9,21,4.1s17.5,2.9,27.2,11.8c9.2,8.4,15.2,28,15.6,29.5l15.4,27.9,5.8,12.3a.45.45,0,0,1,0,.5c-.1.2-.2.3-.4.3-14.1,4.3-29.8,13.6-37.9,18.8a.75.75,0,0,1-.5.1c-.2,0-.3-.2-.4-.3L391,407.3l-8.5,52.1A.68.68,0,0,1,381.9,459.8Zm-128.5-1.3h128l8.8-53.4a.54.54,0,0,1,.5-.5.91.91,0,0,1,.7.3l11.4,20.8c8.2-5.2,23.2-14,36.9-18.3l-5.4-11.6L418.6,368v-.1c-.1-.2-6.1-20.7-15.3-29-9.4-8.6-22.6-11.2-26.4-11.4-4.2-.3-14.8-2.7-21.2-4.1l-1.3-.3c-5.7-1.3-17.4-5-18.7-5.5l-56.2,6.1c-.4,0-43,7.1-52.4,16s-15.2,31.9-17.8,41.8a44.44,44.44,0,0,1-1.5,5.2l-.1.2c-2.1,3.1-6.1,9.3-10.6,16.3,6.5,5.2,19.3,14.2,35.1,18.3L243,402.7a.78.78,0,0,1,.7-.3.54.54,0,0,1,.5.5Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.8,365.3c-5,0-9.6-2-13.9-6-8.1-7.5-11.6-28.5-11.8-29.4l-2.1-6.6a.68.68,0,0,1,.4-.8l.8-.3h.1l56.4-6.1h.3s3.3,1.1,7.2,2.3a.78.78,0,0,1,.4.4l1,3v.2l-.3,5.8c-.3,5.9-4.7,18.8-19.3,29.5C317.9,362.6,311.5,365.3,305.8,365.3Zm-26.5-41.7,2,6c0,.3,3.7,21.5,11.4,28.8,8.6,8.1,18.7,7.4,31.5-2,14.3-10.4,18.6-22.9,18.8-28.6l.3-5.7-.9-2.5c-3.4-1.1-6.3-2-6.8-2.2l-56.2,6.1h-.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.5,378a.71.71,0,0,1-.6-.3c-1-2.1-1.9-4.3-2.7-6.5a.63.63,0,0,1,1.2-.4,50.46,50.46,0,0,0,2.6,6.4.55.55,0,0,1-.3.8h-.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M279,365.3a.63.63,0,0,1-.6-.5,161,161,0,0,1-4.1-31.7.65.65,0,0,1,.6-.6.58.58,0,0,1,.6.6v.1a158,158,0,0,0,4.1,31.4.68.68,0,0,1-.4.8h0Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.1,352.6a.63.63,0,0,1-.6-.5c-2-7.3,2.6-19.8,2.8-20.3a.63.63,0,0,1,1.2.4c0,.1-4.6,12.6-2.7,19.5a.68.68,0,0,1-.4.8h0Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373.3,385.2a.68.68,0,0,1-.6-.4q-1.05-3-1.8-6a.53.53,0,0,1,.5-.7h0a.66.66,0,0,1,.8.5h0a39.83,39.83,0,0,0,1.7,5.9.6.6,0,0,1-.4.8h0Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.2,377.3a.56.56,0,0,1-.6-.5c-2.6-13.8-.1-29.3-.1-29.4.1-.3.4-.6.7-.5s.6.4.5.7-2.5,15.4.1,29a.59.59,0,0,1-.5.7h-.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362,378a.55.55,0,0,1-.5-.3c-2.5-4.4-4.9-14.1-5-14.5a.66.66,0,0,1,.5-.8.62.62,0,0,1,.8.5c0,.1,2.5,9.9,4.9,14.2a.52.52,0,0,1-.2.8h0A1.09,1.09,0,0,1,362,378Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M390.8,405.9a.6.6,0,0,1-.4-.1l-10.8-7.5a.65.65,0,1,1,.7-1.1l7.6,5.3-9-12.1a.63.63,0,0,1,.1-.9h0a.74.74,0,0,1,.9.1l11.3,15.2a.53.53,0,0,1-.1.8A.32.32,0,0,1,390.8,405.9Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.4,403.4a.56.56,0,0,1-.6-.5c0-.2-3.6-15.8-5.5-22.6s-1.7-18.8-1.7-19.3a.65.65,0,0,1,.6-.6h0a.65.65,0,0,1,.6.6h0c0,.1-.3,12.1,1.6,18.9s5.5,22.6,5.5,22.7a.66.66,0,0,1-.5.8Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233.8,379.1a.37.37,0,0,1-.3-.1,29.27,29.27,0,0,1-10.7-11.9.6.6,0,0,1,.4-.8.67.67,0,0,1,.8.3,29.47,29.47,0,0,0,10.3,11.3.65.65,0,0,1,.2.9C234.2,378.9,234,379.1,233.8,379.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M288.2,339.2s4.4,14.1,16,17.7,30.1-18.5,31.5-24.6a66,66,0,0,0,1.4-13.3c0-.8-2.2-21-2.2-21a232.21,232.21,0,0,1-18.5,25.4C305.7,336.2,288.2,339.2,288.2,339.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.9,357.9a9.25,9.25,0,0,1-2.9-.4c-11.8-3.7-16.3-17.6-16.4-18.1a.75.75,0,0,1,.1-.5c.1-.2.2-.3.4-.3s17.3-3.2,27.8-15.5a241,241,0,0,0,18.5-25.3.61.61,0,0,1,.7-.3c.3.1.5.3.5.5.2,2.1,2.2,20.2,2.2,21.1a67,67,0,0,1-1.4,13.4c-1.1,4.7-11.1,17.2-20.5,22.6A20.22,20.22,0,0,1,306.9,357.9ZM289,339.7c1,2.8,5.6,13.6,15.4,16.6,2.9.9,6.6.1,10.8-2.3,9.8-5.6,19-17.8,19.9-21.8a64.06,64.06,0,0,0,1.4-13.1c0-.6-1.1-11.2-2-19.1a217.33,217.33,0,0,1-17.6,24C307.3,335.1,292.5,338.9,289,339.7Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.2,339.2s3.6,11.4,12.8,16.3c3.4-3.5,7.2-8.1,9.1-13,3.9-10,6.4-19.1,6.4-19.1C305.7,336.2,288.2,339.2,288.2,339.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301,356.2a.37.37,0,0,1-.3-.1c-9.3-5-12.9-16.2-13.1-16.7a.75.75,0,0,1,.1-.5c.1-.2.2-.3.4-.3s17.3-3.2,27.8-15.5a.63.63,0,0,1,.9-.1c.2.2.3.4.2.6a186.55,186.55,0,0,1-6.4,19.1,41.86,41.86,0,0,1-9.2,13.2C301.3,356.1,301.2,356.2,301,356.2Zm-12-16.5c.9,2.4,4.5,10.9,11.8,15.1a40.63,40.63,0,0,0,8.6-12.4c2.6-6.7,4.6-13,5.6-16.4C305.5,335.6,292.3,339,289,339.7Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M266.4,264.3s1.4,32.1,2.2,36.9,5.8,17.9,7,21.5,9.2,17.4,16.2,19.3,12.1-.7,16.7-2.9,15-14.2,16.9-17.6,6-11.3,7.5-14.5l1.4-3.1s1.5-30.7,1.7-34.5,3.4-19.8-.2-25.4-17.4-12.8-32.6-13.3-28.7,3.3-33.8,10.1S263.3,260,266.4,264.3Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M296.6,343.3a17.25,17.25,0,0,1-5-.7c-7.5-2.1-15.5-16.4-16.6-19.7-.3-.9-.8-2.3-1.5-4.1-2-5.5-5-13.8-5.6-17.6-.7-4.7-2-34-2.2-36.8-3.1-4.6-2.3-17,3-24,5.1-6.8,18.6-10.9,34.3-10.4,14.8.5,29.1,7.4,33.1,13.6,3,4.7,1.6,15.7.7,22.3a33.91,33.91,0,0,0-.4,3.5c-.2,3.8-1.7,34.2-1.7,34.5v.2l-1.5,3.1c-1.5,3.3-5.6,11.3-7.5,14.5s-12.5,15.7-17.2,17.9l-.6.3A23.17,23.17,0,0,1,296.6,343.3Zm3.9-112c-14.2,0-26.1,3.8-30.7,9.9-5,6.6-5.8,18.6-2.9,22.7a.37.37,0,0,1,.1.3c0,.3,1.4,32.1,2.2,36.9.5,3.6,3.5,11.8,5.5,17.3.6,1.8,1.2,3.2,1.5,4.1,1.3,3.9,9.1,17.1,15.8,18.9s11.3-.5,15.6-2.5l.6-.3c4.4-2.1,14.8-14.1,16.6-17.4s6-11.2,7.5-14.4l1.4-3c.1-2.1,1.5-30.7,1.7-34.4,0-.8.2-2,.4-3.6.8-6,2.2-17.1-.6-21.4-3.3-5-16.6-12.6-32.1-13-.9,0-1.7-.1-2.6-.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.3,261.9c0-1.7,2.9-2.2,2.9-2.2s15,11.3,23.9,10.9,19.8-8.4,23.8-7.7,4.6,4.4,3.4,10.4-1.9,14.7,0,15,5.3-1.3,5.3-1.3-.5,6.3,1.9,6.5,4.6-2.6,4.6-3.4.7-10.4.7-10.4l.4-.2c.2-4.9.5-8.9.5-10.2.2-3.9,3.4-19.8-.2-25.4s-17.4-12.8-32.6-13.3-28.7,3.4-33.7,10.2-6,19.1-2.9,23.4A2.5,2.5,0,0,0,268.3,261.9Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,294.2h-.3c-2.4-.2-2.6-4.2-2.5-6.2a12.67,12.67,0,0,1-4.7.9,2.07,2.07,0,0,1-1-.6c-1.7-2.3-.3-11.7.4-15.1.8-4.1.7-6.7-.3-8.1a3.88,3.88,0,0,0-2.6-1.5c-1.7-.3-5.1,1.3-8.8,2.9-4.7,2.1-10,4.6-15.1,4.8-8.6.5-22.1-9.3-24.1-10.8-.7.2-2.1.7-2.1,1.5a3.46,3.46,0,0,1-2.3,3,.57.57,0,0,1-.7-.2c-3.3-4.5-2.4-17,2.9-24.2,5.1-6.8,18.6-10.9,34.3-10.4,14.8.5,29.1,7.4,33.1,13.6,3,4.7,1.6,15.7.7,22.3a33.91,33.91,0,0,0-.4,3.5c-.1,1.3-.3,5.3-.5,10.2a.51.51,0,0,1-.4.5l-.1.1c-.2,2.9-.7,9.4-.7,10a4.43,4.43,0,0,1-1.7,2.6A6.14,6.14,0,0,1,330,294.2Zm-2.2-7.8a.65.65,0,0,1,.6.6v.1c-.2,2.3.1,5.7,1.4,5.8,2,.2,3.8-2.3,3.9-2.8s.7-9.4.7-10.4a.51.51,0,0,1,.4-.5h.1c.2-4.7.4-8.6.5-9.8,0-.8.2-2,.4-3.6.8-6,2.2-17.1-.6-21.4-3.3-5-16.6-12.6-32.1-13s-28.4,3.4-33.3,9.9-5.8,17.8-3.2,22.2a2.09,2.09,0,0,0,1.1-1.6c0-1.7,2.2-2.6,3.4-2.8a.9.9,0,0,1,.5.1c.1.1,14.9,11.2,23.5,10.7,4.7-.3,10-2.6,14.6-4.7,4.1-1.9,7.4-3.4,9.5-3a5.45,5.45,0,0,1,3.5,2c1.3,1.8,1.3,4.6.4,9.1-1.3,6.4-1.6,12.8-.6,14.1l.1.1a12.65,12.65,0,0,0,5-1.2c0,.1.1.1.2.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M329.4,295.2s2.4-11.6,6.8-11.1,3.9,11.6,1,15.7-5.8,4.8-5.8,4.8",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M331.4,305.3a.63.63,0,0,1-.6-.5.68.68,0,0,1,.4-.8h0s2.7-.8,5.4-4.6c2.1-3,2.8-9.8,1.4-13a2.52,2.52,0,0,0-1.9-1.7c-3.1-.4-5.5,7.7-6.1,10.6a.67.67,0,0,1-1.3-.3c.3-1.3,2.7-12.1,7.4-11.6a3.73,3.73,0,0,1,2.9,2.4c1.6,3.6.9,10.9-1.5,14.3-3,4.3-6,5-6.2,5.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.7,322.2c-5.4,0-6.8-2.9-7.1-3.8-.5-1.5.1-16.3.2-19.3a.6.6,0,0,1,1.2,0c-.3,6.7-.6,17.8-.3,18.8s1.5,2.9,5.9,2.9,5.1-1.3,5.7-2.9a.68.68,0,0,1,.8-.4.63.63,0,0,1,.4.8h0C299.8,320.7,298.4,322.2,293.7,322.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.3,328.7a30.63,30.63,0,0,1-8-.8,9.93,9.93,0,0,1-4.2-3.4.65.65,0,0,1,.2-.9.74.74,0,0,1,.9.1h0a7.9,7.9,0,0,0,3.6,2.9c2,.7,8.7.9,12,.5a12.71,12.71,0,0,0,6.6-2.9.65.65,0,1,1,1.1.7c-.6.9-3.9,2.9-7.4,3.4A28.2,28.2,0,0,1,295.3,328.7Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.2,295.4s14.1-.8,15.7-1-4.3-2.7-9.5-2.7C300.4,291.8,295.4,293.1,299.2,295.4Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.2,296a.37.37,0,0,1-.3-.1c-1.3-.8-1.8-1.6-1.6-2.4.6-2.1,6.4-2.4,8.2-2.4,3.9-.1,10.3,1.6,10.4,3a.91.91,0,0,1-.8.9c-1.7.3-15.3,1-15.9,1Zm6.5-3.6h-.2c-4.3.1-6.8.9-7,1.5,0,.1.1.4.9.9,1.5-.1,10.7-.6,14.2-.9A21.72,21.72,0,0,0,305.7,292.4Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M285.7,295.3s-14.1-.6-15.7-.9,4.3-2.8,9.4-2.8S289.5,293,285.7,295.3Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M285.7,296h0c-.6,0-14.1-.6-15.8-.9-.9-.1-.8-.8-.8-.8.1-1.5,6.4-3.2,10.3-3.2h.1c1.8,0,7.5.2,8.2,2.3.2.8-.3,1.6-1.6,2.4A.52.52,0,0,1,285.7,296Zm-14.4-2c3.6.3,12.7.7,14.2.7.8-.5.9-.8.9-.9-.2-.6-2.7-1.4-7-1.4h-.1A22.37,22.37,0,0,0,271.3,294Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.4,306.3a8,8,0,0,1-6.3-2.7.65.65,0,1,1,1.1-.7h0c.1.2,2.8,3.9,10.1,1.3a.68.68,0,0,1,.8.4.6.6,0,0,1-.4.8h0A19,19,0,0,1,280.4,306.3Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.9,307.5a8,8,0,0,1-6.3-2.7.52.52,0,0,1,.1-.8h0a.63.63,0,0,1,.9.1c.2.2,3.5,4.5,11.4.5a.6.6,0,0,1,.5,1.1h0A14.43,14.43,0,0,1,306.9,307.5Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 305.95,
    y: 385.98,
    width: 30.5,
    height: 61.3,
    transform: "translate(-224.29 410.9) rotate(-54.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.2,447.6a.6.6,0,0,1-.4-.1L287,411.7a1.38,1.38,0,0,1-.3-.4.9.9,0,0,1,.1-.5L304.6,386a.63.63,0,0,1,.9-.1h0l49.8,35.8a.65.65,0,0,1,.2.8h0l-17.8,24.8a1.38,1.38,0,0,1-.4.3ZM288.3,411l48.8,35.1,17.1-23.8-48.8-35.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 310.61,
    y: 390.7,
    width: 21.2,
    height: 52,
    transform: "translate(-224.34 410.94) rotate(-54.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.1,441.1a.6.6,0,0,1-.4-.1l-42.2-30.4a.63.63,0,0,1-.1-.9l12.4-17.2a.63.63,0,0,1,.9-.1h0l42.2,30.4a.65.65,0,0,1,.2.9h0l-12.4,17.2a1.38,1.38,0,0,1-.4.3ZM294.8,410,336,439.7l11.7-16.2-41.2-29.7Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M324,412.8c3.3,2.4,4.7,6,3.1,8.2s-5.5,2-8.8-.4-4.7-6-3.1-8.2S320.7,410.4,324,412.8Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323.7,423.1a10.7,10.7,0,0,1-9.3-6.5,4.41,4.41,0,0,1,1.8-5.9,5.21,5.21,0,0,1,2.8-.5,9.94,9.94,0,0,1,5.4,2c3.6,2.6,5,6.6,3.3,9.1A4.75,4.75,0,0,1,323.7,423.1Zm-5-11.6a3.33,3.33,0,0,0-2.9,1.3,3.71,3.71,0,0,0-.2,3.4,9.38,9.38,0,0,0,3.2,3.9c3,2.2,6.6,2.4,7.9.5s0-5.2-3-7.3a10,10,0,0,0-4.7-1.8Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 310.77,
    y: 383.14,
    width: 30.5,
    height: 61.3,
    transform: "translate(-217.98 339.55) rotate(-46.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.6,446.6a.52.52,0,0,1-.4-.2L292.9,404a.75.75,0,0,1,0-.9h0l21.1-22a.76.76,0,0,1,.4-.2.52.52,0,0,1,.4.2l44.3,42.5a.75.75,0,0,1,0,.9h0l-21.1,22a1,1,0,0,1-.4.1Zm-43.3-43.1,43.4,41.6L357.9,424l-43.4-41.6Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 315.41,
    y: 387.85,
    width: 21.2,
    height: 52,
    transform: "translate(-218.03 339.57) rotate(-46.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.5,440a.52.52,0,0,1-.4-.2l-37.6-36a.75.75,0,0,1,0-.9h0l14.7-15.3a.76.76,0,0,1,.4-.2c.2,0,.3.1.5.2l37.5,36a.75.75,0,0,1,0,.9h0l-14.7,15.3c-.1.2-.2.2-.4.2Zm-36.7-36.6,36.6,35.1,13.8-14.4L314.6,389Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M329.4,410.3c2.9,2.8,3.8,6.6,2,8.6s-5.7,1.3-8.6-1.6-3.8-6.6-2-8.6S326.5,407.5,329.4,410.3Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.5,420.5a6.15,6.15,0,0,1-1.3-.1,10.65,10.65,0,0,1-5-2.7c-3.2-3-4-7.3-2-9.4s6.4-1.5,9.5,1.6,4,7.3,2,9.5A4.32,4.32,0,0,1,328.5,420.5Zm-4.9-12.3a3.58,3.58,0,0,0-2.4.9c-1.6,1.7-.7,5.1,1.9,7.7a9.07,9.07,0,0,0,4.4,2.4,3.59,3.59,0,0,0,3.3-.8c1.6-1.7.7-5.1-1.9-7.7a7.81,7.81,0,0,0-5.3-2.5Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 315.49,
    y: 381.49,
    width: 30.5,
    height: 61.3,
    transform: "translate(-199.03 250.98) rotate(-36.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.5,446.5a.55.55,0,0,1-.5-.3l-36.1-49.6a.63.63,0,0,1,.1-.9h0l24.6-18a.75.75,0,0,1,.5-.1c.2,0,.3.1.4.3l36.1,49.6a.75.75,0,0,1,.1.5c0,.2-.1.3-.3.4l-24.6,18C336.8,446.5,336.6,446.5,336.5,446.5Zm-35.3-50L336.6,445l23.6-17.2-35.4-48.6Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 320.12,
    y: 386.21,
    width: 21.2,
    height: 52,
    transform: "translate(-199.07 250.99) rotate(-36.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.5,440h-.1c-.2,0-.3-.1-.4-.3l-30.7-42a.74.74,0,0,1,.1-.9l17.2-12.6a.75.75,0,0,1,.5-.1c.2,0,.3.1.4.3l30.7,42a.63.63,0,0,1-.1.9h0L338,439.9A1.34,1.34,0,0,1,337.5,440Zm-29.8-42.5,29.9,41,16.1-11.8-29.9-41Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M334.6,409.3c2.4,3.3,2.6,7.2.4,8.8s-5.8.2-8.2-3.1-2.6-7.2-.4-8.8S332.2,406.1,334.6,409.3Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.9,419.3a4.92,4.92,0,0,1-2.1-.4,9.92,9.92,0,0,1-4.5-3.6c-2.6-3.6-2.7-7.9-.3-9.7a5,5,0,0,1,4.6-.4,9.92,9.92,0,0,1,4.5,3.6h0c2.6,3.5,2.7,7.9.3,9.6A3,3,0,0,1,332.9,419.3Zm-4.4-13.1a3.37,3.37,0,0,0-1.7.5c-1.9,1.4-1.6,4.9.6,7.9a8.46,8.46,0,0,0,3.9,3.1,3.44,3.44,0,0,0,3.4-.2c1.9-1.4,1.6-4.9-.6-7.9a8.46,8.46,0,0,0-3.9-3.1A4.67,4.67,0,0,0,328.5,406.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 321.38,
    y: 380.67,
    width: 30.5,
    height: 61.3,
    transform: "translate(-157.6 148.88) rotate(-23.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.1,446.2a.62.62,0,0,1-.6-.4l-24.9-56.1a.45.45,0,0,1,0-.5,1.38,1.38,0,0,1,.3-.4l27.9-12.4a.63.63,0,0,1,.8.3h0l24.9,56.1a.45.45,0,0,1,0,.5q-.15.3-.3.3L335.3,446C335.3,446.2,335.2,446.2,335.1,446.2Zm-24-56.4,24.4,54.9,26.7-11.8L337.8,378Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 325.96,
    y: 385.3,
    width: 21.2,
    height: 52,
    transform: "translate(-157.6 148.85) rotate(-23.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.5,440h-.2a1.38,1.38,0,0,1-.4-.3l-21.1-47.6a.45.45,0,0,1,0-.5q.15-.3.3-.3l19.4-8.6a.63.63,0,0,1,.8.3h0l21.1,47.6a.63.63,0,0,1-.3.8l-19.4,8.5C337.7,440,337.6,440,337.5,440Zm-20.3-47.8,20.6,46.4,18.2-8.1-20.6-46.4Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341,409.4c1.6,3.7,1,7.5-1.4,8.7s-5.7-1-7.4-4.7-1-7.5,1.4-8.7S339.4,405.7,341,409.4Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.2,418.9a5.39,5.39,0,0,1-3-1,9.67,9.67,0,0,1-3.6-4.4c-1.8-4-1-8.3,1.7-9.5s6.4,1.1,8.2,5h0a11.08,11.08,0,0,1,.9,5.7,5.17,5.17,0,0,1-2.6,3.8A2.73,2.73,0,0,1,338.2,418.9ZM335,405a3.59,3.59,0,0,0-1.1.2c-2.1.9-2.6,4.5-1.1,7.8a9.38,9.38,0,0,0,3.2,3.9,3.17,3.17,0,0,0,4.5-.2,3.23,3.23,0,0,0,.8-2.1,8.25,8.25,0,0,0-.8-4.9C339.2,406.8,337,405,335,405Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 326.8,
    y: 381,
    width: 30.5,
    height: 61.3,
    transform: "translate(-102.35 62.92) rotate(-12.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334,445.6a.37.37,0,0,1-.3-.1c-.1-.1-.3-.2-.3-.4l-13.6-59.8a.66.66,0,0,1,.5-.8h0l29.7-6.8a.9.9,0,0,1,.5.1,1.38,1.38,0,0,1,.3.4L364.4,438c.1.3-.1.7-.4.7h0l-29.7,6.7Zm-12.8-60,13.3,58.6,28.5-6.5-13.3-58.6Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 331.41,
    y: 385.71,
    width: 21.2,
    height: 52,
    transform: "translate(-102.36 62.92) rotate(-12.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.5,440a.63.63,0,0,1-.6-.5l-11.5-50.7a.66.66,0,0,1,.5-.8h0l20.7-4.7a.66.66,0,0,1,.8.5l11.5,50.7c.1.3-.1.7-.4.7h0l-20.7,4.7Zm-10.8-50.9,11.2,49.6,19.5-4.4-11.3-49.5Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M346.8,410.6c.9,4-.5,7.6-3.1,8.2s-5.4-2.1-6.3-6.1.5-7.6,3.1-8.2S345.8,406.7,346.8,410.6Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M343,419.5c-2.7,0-5.4-2.8-6.3-6.7a9.25,9.25,0,0,1,.3-5.7,4.35,4.35,0,0,1,5.3-3.2,3.89,3.89,0,0,1,2.3,1.5,9.84,9.84,0,0,1,2.7,5,9.25,9.25,0,0,1-.3,5.7,5,5,0,0,1-3.3,3.3A1.48,1.48,0,0,1,343,419.5Zm-1.8-14.4a1.27,1.27,0,0,0-.6.1,3.55,3.55,0,0,0-2.4,2.5,8.54,8.54,0,0,0-.2,5c.8,3.6,3.3,6.1,5.6,5.6a3.55,3.55,0,0,0,2.4-2.5,8.54,8.54,0,0,0,.2-5h0a8.91,8.91,0,0,0-2.3-4.4,3.85,3.85,0,0,0-2.7-1.3Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M359.3,418s-21.8,8.3-22.9,9.1-11.9,10.8-12.4,12.2l-.6,1.4a1.6,1.6,0,0,0,1.3,1.9h.4s-2.2,3.3-.3,5,4.7.3,4.7.3-2.5,3.9.3,4.7a17.17,17.17,0,0,0,6.4.3s-.6,1.4,9.1,3.3,19.9,2.8,24.3,1.9,14.4-1.9,14.4-1.9,44.2,3.6,53.1,2.8,22.9.6,25.7-3.9-1.4-12.4-4.7-17.4-11-14.4-20.2-14.6a58.46,58.46,0,0,0-20.2,3.9c-5,2.2-16.6,6.9-17.7,7.2s-13-.6-13-.6-23-15.3-24.4-15.6A9.15,9.15,0,0,0,359.3,418Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M433.1,459.6c-13.5,0-47.7-2.8-49.3-2.9,0,0-9.9,1.1-14.2,1.9s-14.8,0-24.6-1.9c-5.4-1.1-8.6-2.2-9.4-3.3a15.63,15.63,0,0,1-6.1-.4,2.48,2.48,0,0,1-1.6-1.4,3.43,3.43,0,0,1,.3-2.8,4.55,4.55,0,0,1-3.9-.9c-1.7-1.4-.9-3.8-.3-5a2.18,2.18,0,0,1-.8-.5,2.51,2.51,0,0,1-.5-1.9v-.2l.6-1.4c.7-1.7,12-11.9,12.7-12.4,1.1-.8,19.4-7.8,23.1-9.2h.1a10.28,10.28,0,0,1,3.5,0c1.4.3,20.3,12.7,24.4,15.5,5.6.4,11.9.7,12.6.6,1-.3,12.6-4.9,17.6-7.2a60.13,60.13,0,0,1,20.5-3.9c10.2.3,18.4,11.5,20.7,14.9,2.5,3.8,7.9,13,4.7,18.1-2.2,3.5-10.2,3.6-18,3.8a70.37,70.37,0,0,0-8.2.4C436.1,459.6,434.8,459.6,433.1,459.6Zm-49.3-4.1c.6,0,44.4,3.6,53.1,2.8,2.5-.2,5.3-.3,8.3-.4,7.1-.1,15.1-.3,17-3.2,2.8-4.5-2.3-13.2-4.7-16.7-2.2-3.3-10.1-14.1-19.7-14.4a56.7,56.7,0,0,0-19.9,3.8c-4.8,2.1-16.6,6.9-17.8,7.2s-11.2-.4-13.2-.5a.37.37,0,0,1-.3-.1c-9-6-22.9-15.1-24.1-15.4a15,15,0,0,0-3,0c-8.7,3.3-21.9,8.4-22.7,9-1.4,1.1-11.7,10.7-12.2,11.9l-.5,1.3a2.92,2.92,0,0,0,.2.9,1.14,1.14,0,0,0,.8.3.86.86,0,0,1,.6.3.64.64,0,0,1,0,.6s-1.9,2.9-.4,4.2,4,.2,4,.2c.2-.1.6-.1.7.1a.75.75,0,0,1,.1.8c-.3.5-1.2,2.2-.8,3.1a.87.87,0,0,0,.8.6,17.91,17.91,0,0,0,6.1.3.73.73,0,0,1,.6.2.37.37,0,0,1,.1.3c.2.2,1.4,1.3,8.6,2.7,9.6,1.9,19.8,2.7,24.1,1.9s14.1-1.8,14.2-1.8ZM336.7,453Zm0,0Zm0,0Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M325,443.2a.86.86,0,0,1-.6-.3.69.69,0,0,1,.3-.9l16.9-9.1.2-.1,19.1-4.7a.68.68,0,0,1,.8.4h0a.66.66,0,0,1-.5.8h0l-19,4.7-16.8,9.1A.76.76,0,0,1,325,443.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.5,448.5a.61.61,0,0,1-.2-1.2l15.8-5.8,17.5-3.3a.61.61,0,1,1,.2,1.2l-17.4,3.3-15.7,5.8Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.1,453.4a.65.65,0,1,1-.1-1.3l15.5-2.2,13.8-1.7a.66.66,0,0,1,.7.6c0,.4-.2.7-.6.7l-13.8,1.7-15.5,2.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M207.5,420.5s13.3,6.6,14.6,6.9,10-.3,10.5,5.8-5,14.4-6.1,18-14.1,2.8-14.1,2.8-4.4-14.9-5.5-20.4S207.5,420.5,207.5,420.5Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.9,454.6c-1.5,0-2.8-.1-3.4-.1a.68.68,0,0,1-.6-.4c0-.2-4.4-15.1-5.5-20.5s.5-12.9.6-13.3c0-.2.2-.3.4-.4a.64.64,0,0,1,.6,0c5.1,2.5,13.5,6.7,14.5,6.9.3,0,.7.1,1,.1,2.8.2,9.5.6,10,6.3.4,4.4-2.3,10-4.2,14-.7,1.4-1.3,2.8-1.9,4.2C226.3,454.1,220.1,454.6,215.9,454.6Zm-2.9-1.3c4.8.3,12.3-.2,13-2.4a34.34,34.34,0,0,1,1.9-4.4c1.9-3.9,4.5-9.2,4.1-13.3-.4-4.6-6.1-5-8.8-5.1-.5,0-.9-.1-1.2-.1-1.3-.3-11.1-5.1-14.1-6.6-.4,2-1.3,7.6-.4,11.9C208.6,438.2,212.2,450.8,213,453.3Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "182.6 374.48 198.6 427.28 203.4 431.98 203.3 425.08 186.8 372.98 182.6 374.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.1,455.6a.52.52,0,0,1-.4-.2l-4.8-4.7c-.1-.1-.1-.2-.2-.3l-16-52.8a.68.68,0,0,1,.4-.8l4.3-1.5a.45.45,0,0,1,.5,0c.2.1.3.2.3.4l16.4,52.1v.2l.1,6.9a.68.68,0,0,1-.4.6A.31.31,0,0,1,223.1,455.6Zm-4.3-5.6,3.6,3.5-.1-5.3-16.2-51.4L203,398Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "186.8 372.98 182.6 374.48 184.5 380.68 188.8 379.28 186.8 372.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.2,404.4a.37.37,0,0,1-.3-.1c-.2-.1-.3-.2-.3-.4l-1.9-6.2a.68.68,0,0,1,.4-.8l4.3-1.5a.45.45,0,0,1,.5,0c.2.1.3.2.3.4l2,6.3a.68.68,0,0,1-.4.8l-4.3,1.5C204.3,404.3,204.2,404.4,204.2,404.4Zm-1.2-6.5,1.5,5,3.1-1.1-1.6-5Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M185.7,451.1s1.7,4.7,3.3,5.3,11.1.3,13.8.3S185.7,451.1,185.7,451.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.4,457.4a29.29,29.29,0,0,1-6.6-.4c-1.9-.6-3.4-4.8-3.8-5.6a.61.61,0,0,1,.1-.6.73.73,0,0,1,.6-.2c18,5,17.9,5.5,17.8,6.1,0,.2-.2.6-.9.6h-2.4Zm7.2-.4Zm-15.9-4.9c.7,1.7,1.7,3.5,2.5,3.8,1.2.4,7.4.3,10.9.3C196.9,455,191.1,453.3,186.7,452.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M189.6,440.6s-4.4,8.3-3.9,10.5,4.7,3.3,8.3,4.2a73,73,0,0,0,15.5.8c3.6-.3-3-3.6-3-3.6a93.31,93.31,0,0,1-10.2-7.2A50.56,50.56,0,0,0,189.6,440.6Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.1,456.8a62.16,62.16,0,0,1-12.2-1c-4.1-.9-8.1-2.1-8.8-4.6-.6-2.3,3.2-9.5,3.9-10.9a.63.63,0,0,1,.8-.3h0a34.94,34.94,0,0,1,6.8,4.8,87.47,87.47,0,0,0,10.1,7.1c3.1,1.5,4.6,2.8,4.4,3.8s-1.3.9-1.6,1C208.6,456.8,207.4,456.8,206.1,456.8Zm-16.4-15.3c-1.6,3.2-3.9,8.1-3.5,9.5.5,2,5.3,3.1,7.8,3.7a71.43,71.43,0,0,0,15.3.8h.4a17.37,17.37,0,0,0-3.6-2.4,92.64,92.64,0,0,1-10.4-7.3,38.17,38.17,0,0,0-6-4.3Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M197.3,432.6s-7.5,5-7.7,8,8,11,9.4,12.1,11,3.6,14.1,3a6,6,0,0,0,4.1-2.8s-9.4-7.2-11.9-11a95.39,95.39,0,0,1-5.5-11.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212,456.5c-3.9,0-12-2.1-13.4-3.3-.1-.1-10-8.9-9.6-12.7.3-3.3,7.2-8,8-8.5l2.5-1.7a.9.9,0,0,1,.5-.1.78.78,0,0,1,.4.4,94,94,0,0,0,5.5,11c2.4,3.8,11.6,10.8,11.7,10.9a.78.78,0,0,1,.2.8,6.48,6.48,0,0,1-4.6,3.1A4.87,4.87,0,0,1,212,456.5Zm-14.7-23.9.4.5c-2,1.3-7.3,5.3-7.5,7.5-.2,2.5,7.2,10,9.2,11.6,1.1.9,10.7,3.5,13.6,2.9a5,5,0,0,0,3.4-2c-1.9-1.5-9.4-7.4-11.6-10.9a103.2,103.2,0,0,1-5.3-10.5l-1.9,1.3Zm0,0Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M207.5,420.5s-10.8,2.8-10.8,6.6,4.7,15.5,7.2,18,11.1,10,13.3,8,.8-3.9.3-5.8-6.9-18.2-6.9-18.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.2,454c-4.1,0-12.7-8.4-12.8-8.5-2.6-2.6-7.4-14.5-7.4-18.4,0-4.2,10.1-7,11.3-7.2a.57.57,0,0,1,.7.4l3,8.6c.3.7,6.4,16.3,6.9,18.3a4.87,4.87,0,0,0,.4,1.1c.6,1.6,1.3,3.5-.8,5.4A2.06,2.06,0,0,1,216.2,454Zm-9.1-32.8c-4,1.1-9.8,3.5-9.8,5.9,0,3.6,4.6,15.1,7,17.6,4,4,11,9.2,12.4,8s1-2.5.5-4c-.1-.4-.3-.8-.4-1.1-.5-1.9-6.8-18-6.9-18.2Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M224.9,428.5s-9.1,17.1-7.5,18.8,4.7,3.3,6.1,2.5,7.2-8.3,8.8-12.4.6-5.8-1.9-7.7A6.8,6.8,0,0,0,224.9,428.5Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222.6,450.6c-1.8,0-4.3-1.5-5.6-2.9-1.7-1.7,3.9-13,7.3-19.5.1-.1.2-.3.4-.3a7.45,7.45,0,0,1,6.1,1.3c2.7,2.1,3.9,4.1,2.1,8.5-1.6,4.1-7.4,11.7-9.1,12.7A3.73,3.73,0,0,1,222.6,450.6Zm2.8-21.6c-4.1,7.7-8,16.6-7.4,17.8,1.7,1.7,4.4,2.9,5.3,2.4,1.2-.7,6.9-7.9,8.6-12.1,1.5-3.8.7-5.1-1.7-7A6.51,6.51,0,0,0,225.4,429Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.3,459.6a3.5,3.5,0,1,1,3.5-3.5h0a3.54,3.54,0,0,1-3.5,3.5Zm0-5.8a2.3,2.3,0,1,0,2.3,2.3h0a2.33,2.33,0,0,0-2.3-2.3Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 148.7,
    y: 432.08,
    width: 78.1,
    height: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.5,459.8H168.4a.65.65,0,0,1-.6-.6v-4.1a.65.65,0,0,1,.6-.6h78.1a.65.65,0,0,1,.6.6v4.1C247.2,459.6,246.9,459.8,246.5,459.8Zm-77.4-1.2h76.8v-2.9H169.1Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 228.6,
    y: 432.08,
    width: 78.1,
    height: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.4,459.8H248.3a.65.65,0,0,1-.6-.6v-4.1a.65.65,0,0,1,.6-.6h78.1a.65.65,0,0,1,.6.6v4.1A.58.58,0,0,1,326.4,459.8Zm-77.5-1.2h76.9v-2.9H248.9Z",
    transform: "translate(-19.7 -23.02)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.3,198.2a19.71,19.71,0,1,1-22.4-16.6h0A19.57,19.57,0,0,1,71.3,198.2Z",
    transform: "translate(-19.7 -23.02)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.7,198.8a15.12,15.12,0,1,1-17.2-12.7h.1a15.12,15.12,0,0,1,17.1,12.7Z",
    transform: "translate(-19.7 -23.02)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.6,198.4a12.2,12.2,0,0,1-.7-1.7,16.41,16.41,0,0,0-2.4-4.3,17.53,17.53,0,0,0-2.3-2.4,14.58,14.58,0,0,0-5.2-2.8,16,16,0,0,0-2.1-.5,16.2,16.2,0,0,0-2.2-.1,14.35,14.35,0,0,0-4.6.8,9.49,9.49,0,0,0-2.1.9,7.07,7.07,0,0,0-1.8,1.2c-.6.4-1.1.9-1.6,1.3a13.31,13.31,0,0,0-2.3,3,17.3,17.3,0,0,0-1.4,3.1,16.14,16.14,0,0,0-.7,4.9,6,6,0,0,1,0,1.9,3.92,3.92,0,0,1-.4-1.8,14.51,14.51,0,0,1,.4-5.1,16.21,16.21,0,0,1,1.3-3.3,15.94,15.94,0,0,1,2.5-3.3c.5-.5,1.1-1,1.7-1.5a17.19,17.19,0,0,1,4.2-2.3,10.55,10.55,0,0,1,2.4-.6,21.05,21.05,0,0,1,2.5-.2,9.74,9.74,0,0,1,2.4.2,15.54,15.54,0,0,1,2.3.5,18,18,0,0,1,2.1.8,16.28,16.28,0,0,1,3.5,2.3,14.42,14.42,0,0,1,2.2,2.7,13.67,13.67,0,0,1,2.1,4.6A3,3,0,0,1,66.6,198.4Z",
    transform: "translate(-19.7 -23.02)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.8,209.6l.4,2.6-2.3.4-.4-2.5a11,11,0,0,1-6-.9l.8-3a9.64,9.64,0,0,0,4.7.9l-.5-3.9c-2.7-.2-5.7-.6-6.2-3.9-.4-2.4,1-4.8,4.6-5.8l-.4-2.6,2.3-.4.4,2.5a10.28,10.28,0,0,1,4.9.7l-.7,3a8,8,0,0,0-3.7-.6l.6,3.9c2.7.2,5.6.6,6.1,3.9C59.8,206.3,58.3,208.6,54.8,209.6Zm-4-9.8-.6-3.3c-1.2.5-1.6,1.2-1.4,2S49.8,199.7,50.8,199.8Zm4.9,4.9c-.1-.8-.9-1.2-1.9-1.3l.5,3.2C55.4,206.1,55.8,205.5,55.7,204.7Z",
    transform: "translate(-19.7 -23.02)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159,254.6l45.1,16.5a6.15,6.15,0,0,1,3.7,7.9l-9.7,26.7a6.15,6.15,0,0,1-7.9,3.7L145,292.9a6.15,6.15,0,0,1-3.7-7.9l9.7-26.7A6.39,6.39,0,0,1,159,254.6Z",
    transform: "translate(-19.7 -23.02)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 172.8,
    y: 244.98,
    width: 8.5,
    height: 60.4,
    transform: "translate(-161.84 324.19) rotate(-69.96)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M167.4,291.4c0,.1-4.7-1.5-10.4-3.6s-10.3-3.8-10.3-3.9,4.7,1.5,10.4,3.6S167.4,291.3,167.4,291.4Z",
    transform: "translate(-19.7 -23.02)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.4,291.1c0,.1-5.7-1.9-12.6-4.4s-12.5-4.6-12.4-4.7,5.7,1.9,12.6,4.4S172.4,291,172.4,291.1Z",
    transform: "translate(-19.7 -23.02)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--credit-card--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M130.6,291.5l47.2-9a6.17,6.17,0,0,1,7.2,4.9l5.3,27.9a6.17,6.17,0,0,1-4.9,7.2l-47.2,9a6.17,6.17,0,0,1-7.2-4.9l-5.3-27.9A6.12,6.12,0,0,1,130.6,291.5Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 126.42,
    y: 295.61,
    width: 60.4,
    height: 8.5,
    transform: "translate(-73.31 11.79) rotate(-10.84)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156.6,318.7c0,.1-4.8,1.1-10.8,2.2s-10.8,2-10.8,1.9,4.8-1.1,10.8-2.2S156.6,318.6,156.6,318.7Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.8,315.9c0,.1-5.8,1.3-13,2.7s-13.1,2.4-13.1,2.3,5.8-1.3,13-2.7S160.8,315.8,160.8,315.9Z",
    transform: "translate(-19.7 -23.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M176,305.5l4.9-.9a1.13,1.13,0,0,1,1.3.9l.9,4.9a1.13,1.13,0,0,1-.9,1.3l-4.9.9a1.13,1.13,0,0,1-1.3-.9l-.9-4.9A1.13,1.13,0,0,1,176,305.5Z",
    transform: "translate(-19.7 -23.02)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27,
    y: 100.28,
    width: 10.3,
    height: 31.3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20 128.38 32.5 142.48 44.2 128.78 20 128.38"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M407.5,240.6a22.58,22.58,0,1,1-20-24.9h.1A22.5,22.5,0,0,1,407.5,240.6Z",
    transform: "translate(-19.7 -23.02)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.9,248.5l-.3,3-2.7-.3.3-2.9a12.39,12.39,0,0,1-6.4-2.8l1.8-3.1a11.63,11.63,0,0,0,5,2.4l.4-4.5c-2.9-1-6.1-2.3-5.7-6.1.3-2.8,2.6-5,6.8-5.1l.3-3,2.7.3-.3,2.9a11,11,0,0,1,5.2,2.2l-1.7,3.1a9.9,9.9,0,0,0-3.9-1.8l-.4,4.5c2.9,1,6,2.3,5.7,6C392.3,246.2,390.1,248.4,385.9,248.5Zm-1.6-12,.4-3.8c-1.5.2-2.1.9-2.2,1.8s.7,1.5,1.8,2Zm4,6.9c.1-.9-.6-1.5-1.7-2l-.4,3.7c1.4-.3,2-.9,2.1-1.7Z",
    transform: "translate(-19.7 -23.02)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.2,238.1a14.92,14.92,0,0,1-.2-2.1,17.55,17.55,0,0,0-3.3-8.8,18.33,18.33,0,0,0-3-3.2,14.29,14.29,0,0,0-2-1.4,22.56,22.56,0,0,0-2.2-1.1,18.29,18.29,0,0,0-2.5-.8,23.36,23.36,0,0,0-2.6-.4,12.19,12.19,0,0,0-2.7,0,15.91,15.91,0,0,0-4.9,1.1,13.55,13.55,0,0,0-2.1,1,17.23,17.23,0,0,0-6,5.7,16,16,0,0,0-2.2,5.2,6.64,6.64,0,0,1-.6,2,3.75,3.75,0,0,1,0-2.1,15.16,15.16,0,0,1,2-5.5,15.94,15.94,0,0,1,2.5-3.3,15.23,15.23,0,0,1,3.7-3c.7-.4,1.5-.8,2.3-1.2a24.13,24.13,0,0,1,2.5-.8,23.25,23.25,0,0,1,2.8-.5,14.05,14.05,0,0,1,2.9,0,12.61,12.61,0,0,1,2.8.5,11.42,11.42,0,0,1,2.6.9c.8.3,1.6.8,2.4,1.2a16.58,16.58,0,0,1,5.2,5,17.76,17.76,0,0,1,1.9,3.6,16.47,16.47,0,0,1,1,5.8A5.83,5.83,0,0,1,402.2,238.1Z",
    transform: "translate(-19.7 -23.02)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M402.2,239.7v-2.4a11,11,0,0,0-.2-1.8,15.65,15.65,0,0,0-1.4-4.8,18.26,18.26,0,0,0-3.8-5.4A16.81,16.81,0,0,0,381,221a9,9,0,0,0-2.3.8,15.05,15.05,0,0,0-2.2,1.1,18,18,0,0,0-4,3.3,15.12,15.12,0,0,0-2.9,4.5,24.62,24.62,0,0,0-1.5,5.3,20.3,20.3,0,0,0,.2,5.5,18.51,18.51,0,0,0,5,9.1,14.62,14.62,0,0,0,1.9,1.6,11.25,11.25,0,0,0,2.1,1.2,17.18,17.18,0,0,0,23-7.8,11.11,11.11,0,0,0,.7-1.6c.2-.6.4-1.1.6-1.7.1-.4.2-.9.3-1.3a2.49,2.49,0,0,0,.1-.8c.2-.3.2-.4.2-.5v.3c0,.2-.1.5-.1.8a6.11,6.11,0,0,1-.3,1.3,12.09,12.09,0,0,1-.5,1.8,19.48,19.48,0,0,1-2.4,4.5,17.56,17.56,0,0,1-4.9,4.5,16.89,16.89,0,0,1-16.7.8,14.79,14.79,0,0,1-2.1-1.3,16.68,16.68,0,0,1-5.2-5.7,18.44,18.44,0,0,1-1.9-5.1,17.46,17.46,0,0,1-.2-5.6,16.69,16.69,0,0,1,1.5-5.4,20.24,20.24,0,0,1,3-4.6,18.57,18.57,0,0,1,4.1-3.3c.7-.4,1.5-.8,2.3-1.2a22.5,22.5,0,0,1,2.4-.8,16.61,16.61,0,0,1,16.1,4.5,17.48,17.48,0,0,1,3.8,5.5,16.12,16.12,0,0,1,1.3,4.9,10.87,10.87,0,0,1,.1,1.8v1.4a2,2,0,0,1-.1.8C402.3,239.5,402.3,239.6,402.2,239.7Z",
    transform: "translate(-19.7 -23.02)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M376.9,258a1.85,1.85,0,0,1-.7-.2,8.86,8.86,0,0,1-1.7-.8,20.28,20.28,0,0,1-5-3.7,18.16,18.16,0,0,1-3.6-5.1,13.36,13.36,0,0,1-.7-1.8,1.45,1.45,0,0,1-.2-.7c.1,0,.4.9,1.2,2.3a22.21,22.21,0,0,0,8.6,8.6C376.1,257.5,377,257.9,376.9,258Z",
    transform: "translate(-19.7 -23.02)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M380.5,259.3c0,.1-.5.1-1-.1s-.9-.4-.9-.5.5-.1,1,.1S380.6,259.2,380.5,259.3Z",
    transform: "translate(-19.7 -23.02)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(152.7 104.28) scale(1.09 1)"
  }, "z", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 38.16,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 53.64,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 115.07,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 159.9,
    y: 0
  }, "a"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(177.4 152.57) scale(1.04 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17"
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.95,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 87.06,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 114.55,
    y: 0
  }, "e"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage1);
export default __webpack_public_path__ + "static/media/manage1.c93cf81a48518cba7f69250097f89323.svg";
export { ForwardRef as ReactComponent };